<template>
    <div class="w-root">
        <div class="w-views">
          <div id="application-wrapper"  :class="{blackbg:!prePaymentModal}">
            <div class="content-wrapper">
              <div class="secondary-menu go-pro">

                <div class="secondary-menu-header" v-if="!prePaymentModal">
                    <i class="back" @click="goTo('/discover')"></i>
                    <p class="logo-tagline">
                        BUDDY<span>PRO</span>
                    </p>
                </div>

                <div ref="vueCustomScrollbar" class="secondary-menu-body">
                  <ProfileSubscriptionCreate @prePaymentShowed="setPrePaymentModal"/>
                </div>

                <BottomBar v-if="isMobile" v-show="!prePaymentModal" tab="profile" />
            </div>
            </div> 
          </div>
        </div><!--w-views-->
    </div><!--w-root-->
</template>

<script>
    import BottomBar from '@buddy/views/widgets/BottomBar.vue';
    import ProfileSubscriptionCreate from '@profile/views/widgets/subscription/ProfileSubscriptionCreate.vue';

    // custom scrollbar
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"

    export default {
        mixins: [
            require('@general/lib/mixin').default
        ],
        data() {
            return {
              prePaymentModal : false,
            }
        },
        components: {
            BottomBar,
            ProfileSubscriptionCreate,
            vueCustomScrollbar,
        },
        methods: {
          setPrePaymentModal(val){
            this.prePaymentModal = val;
          }
        },
    }
</script>
